import { graphql } from "react-relay";

export const QUERY = graphql`
	query offerFilesTable_Query($filterByFileTypes: [String!]) {
		...offerFilesTable_FilesListFragment @arguments(filterByFileTypes: $filterByFileTypes)
	}
`;

export const OFFER_FILES_FRAGMENT = graphql`
	fragment offerFilesTable_FilesListFragment on Query
	@refetchable(queryName: "OfferFilesTable_Refetch")
	@argumentDefinitions(
		first: { type: "Int", defaultValue: 20 }
		after: { type: "String" }
		filterByName: { type: "String" }
		filterByFileTypes: { type: "[String!]" }
		filterByFromDateTimeInclusive: { type: "ZonedDateTIme" }
		filterByToDateTimeInclusive: { type: "ZonedDateTIme" }
		filterFileTagsIncluded: { type: "[String!]" }
		filterFileTagsExcluded: { type: "[String!]", defaultValue: ["IssuedCertificate"] }
	) {
		Admin {
			Offer {
				OfferFiles(
					first: $first
					after: $after
					name: $filterByName
					fileType: $filterByFileTypes
					fromDateTimeInclusive: $filterByFromDateTimeInclusive
					toDateTimeInclusive: $filterByToDateTimeInclusive
					tagsIncluded: $filterFileTagsIncluded
					tagsExcluded: $filterFileTagsExcluded
				) @connection(key: "OfferFilesTable_OfferFiles") {
					__id
					pageInfo {
						endCursor
						hasPreviousPage
						hasNextPage
						startCursor
					}
					edges {
						node {
							id
							name
							fileType
							accessType
							uploadDateTime
							thumbnail
							url
						}
					}
				}
			}
		}
	}
`;

export const DELETE_MUTATION = graphql`
	mutation offerFilesTable_DeleteMutation($input: DeleteOfferFileInput!, $connections: [ID!]!) {
		Admin {
			Offer {
				deleteOfferFile(input: $input) {
					deletedIds @deleteEdge(connections: $connections)
				}
			}
		}
	}
`;
